import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../Configurations/AuthContext';
import './UserDashboardHeader.css'; 

const UserDashboardHeader = () => {
    const { logout } = useAuth();
    const location = useLocation(); 

    const navLinks = [
       { path: '/my-profile', icon: 'ri-user-line', label: 'My Profile' },
        { path: '/my-flightbookings', icon: 'ri-plane-line', label: 'Flight Bookings' },
        { path: '/my-hotelbookings', icon: 'ri-hotel-bed-line', label: 'Hotel Bookings' },

    ];

    return (
        <div className="user-dashboard-header">
            <div className="container">
                <nav className="dashboard-nav">
                    {navLinks.map((link) => (
                        <Link 
                            key={link.path} 
                            to={link.path} 
                            className={`dashboard-link ${location.pathname === link.path ? 'active' : ''}`}
                        >
                            <i className={`${link.icon} me-2`}></i>{link.label}
                        </Link>
                    ))}
                    <button onClick={logout} className="dashboard-link sign-out-btn">
                        <i className="ri-logout-box-r-line me-2"></i>Sign Out
                    </button>
                </nav>
            </div>
        </div>
    );
};

export default UserDashboardHeader;